"use client";
var ct = Object.defineProperty;
var ut = (r, t, u) => t in r ? ct(r, t, { enumerable: !0, configurable: !0, writable: !0, value: u }) : r[t] = u;
var Ie = (r, t, u) => ut(r, typeof t != "symbol" ? t + "" : t, u);
import { j as R } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as dt } from "./tv.config-BuYIgndg.mjs";
import { c as ft, w as pt } from "./capitalize-wVM0qIkw.mjs";
import { l as mt, e as Be, h as gt } from "./Field.style-CQ8CRW6E.mjs";
import * as n from "react";
import { useMemo as ht } from "react";
import { f as yt } from "./helpers-DV5vPbCU.mjs";
import { L as bt } from "./loader-circle-CSITy8jU.mjs";
import { C as xt } from "./chevron-down-YJUEXrSs.mjs";
import { u as T, s as v, S as vt, a as St, b as he, c as Rt, i as wt, O as Tt } from "./Option-Omg-vJyi.mjs";
import { F as Mt, a as Ue, b as Ct } from "./FieldDescription-LT07Zs4i.mjs";
import { F as At } from "./FieldLabel-C2NVcnds.mjs";
import { v as It } from "./visuallyHidden-DPuANzJJ.mjs";
import { a as Vt, b as ke, c as Ye, m as Et, u as ye, D as Pt, f as Nt } from "./useRenderElement-B8V3_e8R.mjs";
import { u as Le } from "./useControlled-B2rPEZCb.mjs";
import { u as ie } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as ae } from "./useEventCallback-CjuAhyNz.mjs";
import { u as ge } from "./useTimeout-BRUciAq6.mjs";
import { w as Ot } from "./warn-BEDWsnVv.mjs";
import { u as qe } from "./useLatestRef-BZ_hd_SE.mjs";
import { u as Ht, a as Dt } from "./useFieldControlValidation-B3M7EPH2.mjs";
import { u as Ee, f as jt } from "./FieldRootContext-Cj7-dNhd.mjs";
import { u as Ft } from "./useBaseUiId-a-UPSsPQ.mjs";
import { u as Xe, a as De } from "./useOpenChangeComplete-CXAVaIGe.mjs";
import { u as Bt, a as Ut, b as kt, t as Lt } from "./translateOpenChangeReason-C857LgAi.mjs";
import { u as Wt } from "./FormContext-CYX6HnEQ.mjs";
import { u as _t } from "./useFloatingRootContext-BSTWPoxk.mjs";
import { a as zt, u as $t, I as Yt, F as qt } from "./useScrollLock-COQT0_go.mjs";
import { u as Xt, a as Kt, g as Jt } from "./getPseudoElementBounds-D3t2tvmN.mjs";
import { o as Oe } from "./owner-DpSCkBia.mjs";
import { a as Zt, p as Ke } from "./popupStateMapping-Cl0RMVD6.mjs";
import { u as Gt } from "./useButton-CQeWQM5o.mjs";
import { c as We } from "./element-DE7VsBMX.mjs";
import { F as Qt } from "./FloatingPortal-B6chGyBH.mjs";
import { i as eo } from "./inertValue-CseOXFGF.mjs";
import { C as to } from "./CompositeList-BwSEPM9t.mjs";
import { u as oo } from "./useAnchorPositioning-DZydZPwe.mjs";
import * as no from "react-dom";
import { c as ro } from "./detectBrowser-CpuomNQW.mjs";
import { s as _e } from "./styles-HANmOD1N.mjs";
import { t as so } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { k as ze } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
function io(r) {
  const t = n.useRef(!0);
  t.current && (t.current = !1, r());
}
class lo {
  constructor(t) {
    /**
     * Registers a listener that will be called whenever the store's state changes.
     *
     * @param fn The listener function to be called on state changes.
     * @returns A function to unsubscribe the listener.
     */
    Ie(this, "subscribe", (t) => (this.listeners.add(t), () => {
      this.listeners.delete(t);
    }));
    /**
     * Returns the current state of the store.
     */
    Ie(this, "getSnapshot", () => this.state);
    /**
     * Updates the entire store's state and notifies all registered listeners.
     *
     * @param newState The new state to set for the store.
     */
    Ie(this, "update", (t) => {
      this.state !== t && (this.state = t, this.listeners.forEach((u) => u(t)));
    });
    this.state = t, this.listeners = /* @__PURE__ */ new Set();
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  apply(t) {
    for (const u in t)
      if (!Object.is(this.state[u], t[u])) {
        this.update({
          ...this.state,
          ...t
        });
        return;
      }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(t, u) {
    Object.is(this.state[t], u) || this.update({
      ...this.state,
      [t]: u
    });
  }
}
function ao(r) {
  const {
    id: t,
    disabled: u = !1,
    readOnly: V = !1,
    required: q = !1,
    modal: g = !1,
    name: w,
    onOpenChangeComplete: S,
    items: H,
    multiple: d = !1
  } = r, {
    clearErrors: y
  } = Wt(), {
    setDirty: B,
    validityData: D,
    validationMode: _,
    setControlId: M,
    setFilled: j,
    name: O,
    disabled: $
  } = Ee(), b = Ht(), o = Ft(t), E = $ || u, m = O ?? w;
  ie(() => (M(o), () => {
    M(void 0);
  }), [o, M]);
  const [s, z] = Le({
    controlled: r.value,
    default: d ? r.defaultValue ?? ke : r.defaultValue,
    name: "Select",
    state: "value"
  }), [A, e] = Le({
    controlled: r.open,
    default: r.defaultOpen,
    name: "Select",
    state: "open"
  }), p = n.useRef([]), c = n.useRef([]), C = n.useRef(null), L = n.useRef(null), a = n.useRef([]), P = n.useRef(!1), I = n.useRef(!1), W = n.useRef(null), x = n.useRef(null), h = n.useRef({
    allowSelectedMouseUp: !1,
    allowUnselectedMouseUp: !1,
    allowSelect: !1
  }), F = n.useRef(!1), l = n.useRef(!1), U = ge(), {
    mounted: N,
    setMounted: Z,
    transitionStatus: te
  } = Xe(A), i = Vt(() => new lo({
    id: o,
    modal: g,
    multiple: d,
    value: s,
    label: "",
    open: A,
    mounted: N,
    forceMount: !1,
    transitionStatus: te,
    items: H,
    touchModality: !1,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    triggerProps: {},
    triggerElement: null,
    positionerElement: null,
    scrollUpArrowVisible: !1,
    scrollDownArrowVisible: !1
  })).current, X = n.useRef(s);
  ie(() => {
    s !== X.current && i.set("forceMount", !0);
  }, [i, s]);
  const J = T(i, v.activeIndex), k = T(i, v.selectedIndex), ce = T(i, v.triggerElement), ue = T(i, v.positionerElement), ee = qe(i.state.triggerElement), G = b.commitValidation;
  Dt({
    id: o,
    commitValidation: G,
    value: s,
    controlRef: ee,
    name: m,
    getValue: () => s
  });
  const le = n.useRef(s);
  ie(() => {
    j(s !== null);
  }, [s, j]), ie(() => {
    if (le.current !== s) {
      if (d) {
        const f = Array.isArray(s) ? s : [], K = f.map((re) => {
          const me = a.current.indexOf(re);
          return me !== -1 ? c.current[me] ?? "" : "";
        }).filter(Boolean), Y = f[f.length - 1], Q = Y != null ? a.current.indexOf(Y) : -1;
        x.current = Q === -1 ? null : Q, i.apply({
          label: K.join(", ")
        });
      } else {
        const f = a.current.indexOf(s);
        i.apply({
          selectedIndex: f === -1 ? null : f,
          label: c.current[f] ?? ""
        });
      }
      y(m), B(s !== D.initialValue), G(s, _ !== "onChange"), _ === "onChange" && G(s);
    }
  }, [s, G, y, m, _, i, B, D.initialValue, j, d]), ie(() => {
    le.current = s;
  }, [s]);
  const de = ae((f, K, Y) => {
    var Q;
    if ((Q = r.onOpenChange) == null || Q.call(r, f, K, Y), e(f), !f && d && i.set("selectedIndex", x.current), !f && i.state.activeIndex !== null) {
      const re = p.current[i.state.activeIndex];
      queueMicrotask(() => {
        re == null || re.setAttribute("tabindex", "-1");
      });
    }
  }), be = ae(() => {
    Z(!1), i.set("activeIndex", null), S == null || S(!1);
  });
  De({
    enabled: !r.actionsRef,
    open: A,
    ref: C,
    onComplete() {
      A || be();
    }
  }), n.useImperativeHandle(r.actionsRef, () => ({
    unmount: be
  }), [be]);
  const fe = ae((f, K) => {
    var Y;
    (Y = r.onValueChange) == null || Y.call(r, f, K), z(f);
  }), oe = ae(() => {
    if (F.current)
      if (d) {
        const f = Array.isArray(s) ? s : [], K = f.map((me) => {
          const Se = a.current.indexOf(me);
          return Se !== -1 ? c.current[Se] ?? "" : "";
        }).filter(Boolean), Y = f[f.length - 1], Q = Y !== void 0 ? a.current.indexOf(Y) : -1;
        x.current = Q === -1 ? null : Q;
        let re = i.state.selectedIndex;
        re === null && (re = Q === -1 ? null : Q), i.apply({
          selectedIndex: re,
          label: K.join(", ")
        });
      } else {
        const f = a.current.indexOf(s), K = f !== -1;
        if (K || s === null) {
          i.apply({
            selectedIndex: K ? f : null,
            label: K ? c.current[f] ?? "" : ""
          });
          return;
        }
        if (process.env.NODE_ENV !== "production" && s) {
          const Y = typeof s == "string" || s === null ? s : JSON.stringify(s);
          Ot(`The value \`${Y}\` is not present in the select items.`);
        }
      }
  }), we = ae((f) => {
    F.current = !0, d && (x.current = f), oe();
  });
  ie(oe, [s, oe]);
  const se = _t({
    open: A,
    onOpenChange(f, K, Y) {
      de(f, K, Lt(Y));
    },
    elements: {
      reference: ce,
      floating: ue
    }
  }), Te = Bt(se, {
    enabled: !V && !E,
    event: "mousedown"
  }), Me = Ut(se, {
    bubbles: !1
  }), Ce = zt(se, {
    role: "select"
  }), Ae = Xt(se, {
    enabled: !V && !E,
    listRef: p,
    activeIndex: J,
    selectedIndex: k,
    disabledIndices: ke,
    onNavigate(f) {
      f === null && !A || i.set("activeIndex", f);
    },
    // Implement our own listeners since `onPointerLeave` on each option fires while scrolling with
    // the `alignItemWithTrigger=true`, causing a performance issue on Chrome.
    focusItemOnHover: !1
  }), xe = Kt(se, {
    enabled: !V && !E && (A || !d),
    listRef: c,
    activeIndex: J,
    selectedIndex: k,
    onMatch(f) {
      A ? i.set("activeIndex", f) : fe(a.current[f]);
    },
    onTypingChange(f) {
      P.current = f;
    }
  }), {
    getReferenceProps: ne,
    getFloatingProps: ve,
    getItemProps: pe
  } = kt([Te, Me, Ce, Ae, xe]);
  return io(() => {
    i.apply({
      popupProps: ve(),
      triggerProps: ne()
    });
  }), n.useEffect(() => {
    i.apply({
      id: o,
      modal: g,
      multiple: d,
      value: s,
      open: A,
      mounted: N,
      transitionStatus: te,
      popupProps: ve(),
      triggerProps: ne()
    });
  }, [i, o, g, d, s, A, N, te, ve, ne]), {
    rootContext: n.useMemo(() => ({
      store: i,
      name: m,
      required: q,
      disabled: E,
      readOnly: V,
      multiple: d,
      setValue: fe,
      setOpen: de,
      listRef: p,
      popupRef: C,
      getItemProps: pe,
      events: se.events,
      valueRef: L,
      valuesRef: a,
      labelsRef: c,
      typingRef: P,
      selectionRef: h,
      selectedItemTextRef: W,
      fieldControlValidation: b,
      registerItemIndex: we,
      onOpenChangeComplete: S,
      keyboardActiveRef: I,
      alignItemWithTriggerActiveRef: l,
      highlightTimeout: U
    }), [i, m, q, E, V, d, fe, de, p, C, pe, se.events, L, a, c, P, h, W, b, we, S, I, l, U]),
    floatingContext: se,
    value: s
  };
}
function $e(r) {
  if (r == null)
    return "";
  if (typeof r == "string")
    return r;
  try {
    return JSON.stringify(r);
  } catch {
    return String(r);
  }
}
function co(r) {
  const {
    id: t,
    value: u,
    defaultValue: V = null,
    onValueChange: q,
    open: g,
    defaultOpen: w = !1,
    onOpenChange: S,
    name: H,
    disabled: d = !1,
    readOnly: y = !1,
    required: B = !1,
    modal: D = !0,
    actionsRef: _,
    inputRef: M,
    onOpenChangeComplete: j,
    items: O,
    multiple: $,
    children: b
  } = r, {
    rootContext: o,
    floatingContext: E,
    value: m
  } = ao({
    id: t,
    value: u,
    defaultValue: V,
    onValueChange: q,
    open: g,
    defaultOpen: w,
    onOpenChange: S,
    name: H,
    disabled: d,
    readOnly: y,
    required: B,
    modal: D,
    actionsRef: _,
    onOpenChangeComplete: j,
    items: O,
    multiple: $
  }), s = o.store, z = $ ?? !1, {
    setDirty: A,
    validityData: e,
    validationMode: p,
    controlId: c
  } = Ee(), C = Ye(M, o.fieldControlValidation.inputRef), L = n.useMemo(() => z && Array.isArray(m) && m.length === 0 ? "" : $e(m), [z, m]), a = n.useMemo(() => !z || !Array.isArray(m) || !o.name ? null : m.map((P) => {
    const I = $e(P);
    return /* @__PURE__ */ R.jsx("input", {
      type: "hidden",
      name: o.name,
      value: I
    }, I);
  }), [z, m, o.name]);
  return /* @__PURE__ */ R.jsx(vt.Provider, {
    value: o,
    children: /* @__PURE__ */ R.jsxs(St.Provider, {
      value: E,
      children: [b, /* @__PURE__ */ R.jsx("input", {
        ...o.fieldControlValidation.getInputValidationProps({
          onFocus() {
            var P;
            (P = s.state.triggerElement) == null || P.focus();
          },
          // Handle browser autofill.
          onChange(P) {
            if (P.nativeEvent.defaultPrevented)
              return;
            const I = P.target.value;
            s.set("forceMount", !0), queueMicrotask(() => {
              var W;
              if (!z) {
                const x = o.valuesRef.current.find((h) => h === I || typeof m == "string" && I.toLowerCase() === h.toLowerCase());
                x != null && (A(x !== e.initialValue), (W = o.setValue) == null || W.call(o, x, P.nativeEvent), p === "onChange" && o.fieldControlValidation.commitValidation(x));
              }
            });
          },
          id: t || c || void 0,
          name: z ? void 0 : o.name,
          value: L,
          disabled: o.disabled,
          required: o.required,
          readOnly: o.readOnly,
          ref: C,
          style: It,
          tabIndex: -1,
          "aria-hidden": !0
        })
      }), a]
    })
  });
}
const Ve = 2, uo = {
  ...Zt,
  ...jt,
  value: () => null
}, Je = /* @__PURE__ */ n.forwardRef(function(t, u) {
  const {
    render: V,
    className: q,
    disabled: g = !1,
    nativeButton: w = !1,
    ...S
  } = t, {
    state: H,
    disabled: d
  } = Ee(), {
    store: y,
    setOpen: B,
    selectionRef: D,
    fieldControlValidation: _,
    readOnly: M,
    alignItemWithTriggerActiveRef: j,
    disabled: O,
    keyboardActiveRef: $
  } = he(), b = d || O || g, o = T(y, v.open), E = T(y, v.value), m = T(y, v.triggerProps), s = T(y, v.positionerElement), z = qe(s), {
    labelId: A,
    setTouched: e,
    setFocused: p,
    validationMode: c
  } = Ee(), C = n.useRef(null), L = ge(), a = ge(), {
    getButtonProps: P,
    buttonRef: I
  } = Gt({
    disabled: b,
    native: w
  }), W = ae((N) => {
    y.set("triggerElement", N);
  }), x = Ye(u, C, I, W), h = ge(), F = ge();
  n.useEffect(() => {
    if (o)
      return F.start(200, () => {
        D.current.allowUnselectedMouseUp = !0, h.start(200, () => {
          D.current.allowSelectedMouseUp = !0;
        });
      }), () => {
        h.clear(), F.clear();
      };
    D.current = {
      allowSelectedMouseUp: !1,
      allowUnselectedMouseUp: !1,
      allowSelect: !0
    }, a.clear();
  }, [o, D, a, h, F]);
  const l = Et(m, {
    "aria-labelledby": A,
    "aria-readonly": M || void 0,
    tabIndex: b ? -1 : 0,
    ref: x,
    onFocus(N) {
      p(!0), o && j.current && B(!1, N.nativeEvent, "focus-out"), L.start(0, () => {
        y.set("forceMount", !0);
      });
    },
    onBlur() {
      e(!0), p(!1), c === "onBlur" && _.commitValidation(E);
    },
    onPointerMove({
      pointerType: N
    }) {
      $.current = !1, y.set("touchModality", N === "touch");
    },
    onPointerDown({
      pointerType: N
    }) {
      y.set("touchModality", N === "touch");
    },
    onKeyDown(N) {
      $.current = !0, N.key === "ArrowDown" && B(!0, N.nativeEvent, "list-navigation");
    },
    onMouseDown(N) {
      if (o)
        return;
      const Z = Oe(N.currentTarget);
      function te(i) {
        if (!C.current)
          return;
        const X = i.target;
        if (We(C.current, X) || We(z.current, X) || X === C.current)
          return;
        const J = Jt(C.current);
        i.clientX >= J.left - Ve && i.clientX <= J.right + Ve && i.clientY >= J.top - Ve && i.clientY <= J.bottom + Ve || B(!1, i, "cancel-open");
      }
      a.start(0, () => {
        Z.addEventListener("mouseup", te, {
          once: !0
        });
      });
    }
  }, _.getValidationProps, S, P);
  l.role = "combobox";
  const U = n.useMemo(() => ({
    ...H,
    open: o,
    disabled: b,
    value: E,
    readOnly: M
  }), [H, o, b, M, E]);
  return ye("div", t, {
    ref: [u, C],
    state: U,
    customStyleHookMapping: uo,
    props: l
  });
});
process.env.NODE_ENV !== "production" && (Je.displayName = "SelectTrigger");
const fo = {
  value: () => null
}, Ze = /* @__PURE__ */ n.forwardRef(function(t, u) {
  const {
    className: V,
    render: q,
    children: g,
    ...w
  } = t, {
    store: S,
    valueRef: H
  } = he(), d = T(S, v.value), y = T(S, v.items), B = typeof g == "function", D = n.useMemo(() => {
    var O;
    if (!B) {
      if (Array.isArray(d))
        return d.join(", ");
      if (y)
        return Array.isArray(y) ? (O = y.find(($) => $.value === d)) == null ? void 0 : O.label : y[d];
    }
  }, [d, y, B]), _ = n.useMemo(() => ({
    value: d
  }), [d]), M = typeof g == "function" ? g(d) : g ?? D ?? d;
  return ye("span", t, {
    state: _,
    ref: [u, H],
    props: [{
      children: M
    }, w],
    customStyleHookMapping: fo
  });
});
process.env.NODE_ENV !== "production" && (Ze.displayName = "SelectValue");
const Ge = /* @__PURE__ */ n.forwardRef(function(t, u) {
  const {
    className: V,
    render: q,
    ...g
  } = t;
  return ye("span", t, {
    ref: u,
    props: [{
      "aria-hidden": !0,
      children: "▼"
    }, g]
  });
});
process.env.NODE_ENV !== "production" && (Ge.displayName = "SelectIcon");
const Qe = /* @__PURE__ */ n.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qe.displayName = "SelectPortalContext");
function po(r) {
  const {
    children: t,
    container: u
  } = r, {
    store: V
  } = he(), q = T(V, v.mounted), g = T(V, v.forceMount);
  return q || g ? /* @__PURE__ */ R.jsx(Qe.Provider, {
    value: !0,
    children: /* @__PURE__ */ R.jsx(Qt, {
      root: u,
      children: t
    })
  }) : null;
}
const je = /* @__PURE__ */ n.createContext(void 0);
process.env.NODE_ENV !== "production" && (je.displayName = "SelectPositionerContext");
function et() {
  const r = n.useContext(je);
  if (!r)
    throw new Error("Base UI: SelectPositionerContext is missing. SelectPositioner parts must be placed within <Select.Positioner>.");
  return r;
}
function He(r, t) {
  Object.assign(r.style, t);
}
const mo = {
  position: "fixed"
}, tt = /* @__PURE__ */ n.forwardRef(function(t, u) {
  const {
    anchor: V,
    positionMethod: q = "absolute",
    className: g,
    render: w,
    side: S = "bottom",
    align: H = "center",
    sideOffset: d = 0,
    alignOffset: y = 0,
    collisionBoundary: B = "clipping-ancestors",
    collisionPadding: D,
    arrowPadding: _ = 5,
    sticky: M = !1,
    trackAnchor: j = !0,
    alignItemWithTrigger: O = !0,
    collisionAvoidance: $ = Pt,
    ...b
  } = t, {
    store: o,
    listRef: E,
    labelsRef: m,
    alignItemWithTriggerActiveRef: s,
    valuesRef: z
  } = he(), A = Rt(), e = T(o, v.open), p = T(o, v.mounted), c = T(o, v.modal), C = T(o, v.value), L = T(o, v.touchModality), a = T(o, v.positionerElement), P = T(o, v.triggerElement), [I, W] = n.useState(O), x = p && I && !L;
  !p && I !== O && W(O), ie(() => {
    (!O || !p) && (v.scrollUpArrowVisible(o.state) && o.set("scrollUpArrowVisible", !1), v.scrollDownArrowVisible(o.state) && o.set("scrollDownArrowVisible", !1));
  }, [o, p, O]), n.useImperativeHandle(s, () => x), $t({
    enabled: (x || c) && e && !L,
    mounted: p,
    open: e,
    referenceElement: P
  });
  const h = oo({
    anchor: V,
    floatingRootContext: A,
    positionMethod: q,
    mounted: p,
    side: S,
    sideOffset: d,
    align: H,
    alignOffset: y,
    arrowPadding: _,
    collisionBoundary: B,
    collisionPadding: D,
    sticky: M,
    trackAnchor: j ?? !x,
    collisionAvoidance: $,
    keepMounted: !0
  }), F = x ? "none" : h.side, l = x ? mo : h.positionerStyles, U = n.useMemo(() => {
    const k = {};
    return e || (k.pointerEvents = "none"), {
      role: "presentation",
      hidden: !p,
      style: {
        ...l,
        ...k
      }
    };
  }, [e, p, l]), N = n.useMemo(() => ({
    open: e,
    side: F,
    align: h.align,
    anchorHidden: h.anchorHidden
  }), [e, F, h.align, h.anchorHidden]), Z = ae((k) => {
    o.set("positionerElement", k);
  }), te = ye("div", t, {
    ref: [u, Z],
    state: N,
    customStyleHookMapping: Ke,
    props: [U, b]
  }), i = n.useRef(0), X = ae((k) => {
    if (k.size === 0 && i.current === 0 || z.current.length === 0)
      return;
    const ce = i.current;
    i.current = k.size, k.size !== ce && (!o.state.multiple && C !== null && z.current.indexOf(C) === -1 && o.apply({
      label: "",
      selectedIndex: null
    }), e && x && (o.apply({
      scrollUpArrowVisible: !1,
      scrollDownArrowVisible: !1
    }), a && He(a, {
      height: ""
    })));
  }), J = n.useMemo(() => ({
    ...h,
    side: F,
    alignItemWithTriggerActive: x,
    setControlledAlignItemWithTrigger: W
  }), [h, F, x, W]);
  return /* @__PURE__ */ R.jsx(to, {
    elementsRef: E,
    labelsRef: m,
    onMapChange: X,
    children: /* @__PURE__ */ R.jsxs(je.Provider, {
      value: J,
      children: [p && c && /* @__PURE__ */ R.jsx(Yt, {
        inert: eo(!e),
        cutout: P
      }), te]
    })
  });
});
process.env.NODE_ENV !== "production" && (tt.displayName = "SelectPositioner");
const go = {
  ...Ke,
  ...so
}, ot = /* @__PURE__ */ n.forwardRef(function(t, u) {
  const {
    render: V,
    className: q,
    ...g
  } = t, {
    store: w,
    popupRef: S,
    onOpenChangeComplete: H,
    setOpen: d,
    valueRef: y,
    selectedItemTextRef: B,
    keyboardActiveRef: D,
    highlightTimeout: _,
    multiple: M
  } = he(), {
    side: j,
    align: O,
    context: $,
    alignItemWithTriggerActive: b,
    setControlledAlignItemWithTrigger: o
  } = et(), E = T(w, v.open), m = T(w, v.mounted), s = T(w, v.popupProps), z = T(w, v.transitionStatus), A = T(w, v.triggerElement), e = T(w, v.positionerElement), p = T(w, v.scrollUpArrowVisible), c = T(w, v.scrollDownArrowVisible);
  De({
    open: E,
    ref: S,
    onComplete() {
      E && (H == null || H(!0));
    }
  });
  const C = n.useMemo(() => ({
    open: E,
    transitionStatus: z,
    side: j,
    align: O
  }), [E, z, j, O]), L = n.useRef(0), a = n.useRef(!1), P = n.useRef(0), I = n.useRef(!1), W = n.useRef({}), x = ae(() => {
    if (!b || !S.current)
      return;
    const l = S.current.scrollTop < 1, U = S.current.scrollTop + S.current.clientHeight >= S.current.scrollHeight - 1;
    p !== !l && w.set("scrollUpArrowVisible", !l), c !== !U && w.set("scrollDownArrowVisible", !U);
  });
  ie(() => {
    !e || Object.keys(W.current).length || (W.current = {
      top: e.style.top || "0",
      left: e.style.left || "0",
      right: e.style.right,
      height: e.style.height,
      bottom: e.style.bottom,
      minHeight: e.style.minHeight,
      maxHeight: e.style.maxHeight,
      marginTop: e.style.marginTop,
      marginBottom: e.style.marginBottom
    });
  }, [e]), ie(() => {
    m || b || (I.current = !1, a.current = !1, L.current = 0, P.current = 0, e && He(e, W.current));
  }, [m, b, e]), ie(() => {
    const l = S.current;
    !m || !b || !A || !e || !S.current || !l || queueMicrotask(() => {
      var Se;
      const U = getComputedStyle(e), N = getComputedStyle(l), Z = Oe(A), te = ze(e), i = A.getBoundingClientRect(), X = e.getBoundingClientRect(), J = i.left, k = i.height, ce = l.scrollHeight, ue = parseFloat(N.borderBottomWidth), ee = parseFloat(U.marginTop) || 10, G = parseFloat(U.marginBottom) || 10, le = parseFloat(U.minHeight) || 100, de = 5, be = 5, fe = 20, oe = Z.documentElement.clientHeight - ee - G, we = Z.documentElement.clientWidth, se = oe - i.bottom + k, Te = B.current, Me = y.current;
      let Ce = 0, Ae = 0;
      if (Te && Me) {
        const Re = Me.getBoundingClientRect(), Ne = Te.getBoundingClientRect(), st = Re.left - J, it = Ne.left - X.left, lt = Re.top - i.top + Re.height / 2, at = Ne.top - X.top + Ne.height / 2;
        Ce = st - it, Ae = at - lt;
      }
      const xe = se + Ae + G + ue;
      let ne = Math.min(oe, xe);
      const ve = oe - ee - G, pe = xe - ne, Pe = Math.max(de, J + Ce), f = we - be, K = Math.max(0, Pe + X.width - f);
      e.style.left = `${Pe - K}px`, e.style.height = `${ne}px`, e.style.maxHeight = "auto", e.style.marginTop = `${ee}px`, e.style.marginBottom = `${G}px`;
      const Y = l.scrollHeight - l.clientHeight, Q = pe >= Y;
      Q && (ne = Math.min(oe, X.height) - (pe - Y));
      const re = i.top < fe || i.bottom > oe - fe || ne < Math.min(ce, le), me = (((Se = te.visualViewport) == null ? void 0 : Se.scale) ?? 1) !== 1 && ro;
      if (re || me) {
        I.current = !0, He(e, W.current), no.flushSync(() => o(!1));
        return;
      }
      if (Q) {
        const Re = Math.max(0, oe - xe);
        e.style.top = X.height >= ve ? "0" : `${Re}px`, e.style.height = `${ne}px`, l.scrollTop = l.scrollHeight - l.clientHeight, L.current = Math.max(le, ne);
      } else
        e.style.bottom = "0", L.current = Math.max(le, ne), l.scrollTop = pe;
      L.current === oe && (a.current = !0), x(), setTimeout(() => {
        I.current = !0;
      });
    });
  }, [w, m, e, A, y, B, S, x, b, o]), n.useEffect(() => {
    if (!b || !e || !m)
      return;
    const l = ze(e);
    function U(N) {
      d(!1, N, "window-resize");
    }
    return l.addEventListener("resize", U), () => {
      l.removeEventListener("resize", U);
    };
  }, [d, b, e, m]);
  const h = {
    "aria-multiselectable": M || void 0,
    onKeyDown() {
      D.current = !0;
    },
    onMouseMove() {
      D.current = !1;
    },
    onPointerLeave(l) {
      if (wt(l) || l.pointerType === "touch")
        return;
      const U = l.currentTarget;
      _.start(0, () => {
        w.set("activeIndex", null), U.focus({
          preventScroll: !0
        });
      });
    },
    onScroll(l) {
      if (!b || !e || !S.current || !I.current)
        return;
      if (a.current) {
        x();
        return;
      }
      const U = e.style.top === "0px", N = e.style.bottom === "0px", Z = e.getBoundingClientRect().height, te = Oe(e), i = getComputedStyle(e), X = parseFloat(i.marginTop), J = parseFloat(i.marginBottom), k = te.documentElement.clientHeight - X - J;
      if (U) {
        const ce = l.currentTarget.scrollTop, ue = l.currentTarget.scrollHeight - l.currentTarget.clientHeight, ee = ue - ce, G = Math.min(Z + ee, k);
        e.style.height = `${Math.min(Z + ee, k)}px`, G !== k ? l.currentTarget.scrollTop = ue : a.current = !0;
      } else if (N) {
        const ee = l.currentTarget.scrollTop - 0, G = Math.min(Z + ee, k), le = Z + ee, de = le - k;
        e.style.height = `${Math.min(le, k)}px`, G !== k ? l.currentTarget.scrollTop = 0 : (a.current = !0, l.currentTarget.scrollTop < l.currentTarget.scrollHeight - l.currentTarget.clientHeight && (l.currentTarget.scrollTop -= ee - de));
      }
      x();
    },
    ...b && {
      style: {
        position: "relative",
        maxHeight: "100%",
        overflowX: "hidden",
        overflowY: "auto"
      }
    }
  }, F = ye("div", t, {
    ref: [u, S],
    state: C,
    customStyleHookMapping: go,
    props: [s, h, {
      style: z === "starting" ? Nt.style : void 0,
      className: b ? _e.className : void 0
    }, g]
  });
  return /* @__PURE__ */ R.jsxs(n.Fragment, {
    children: [_e.element, /* @__PURE__ */ R.jsx(qt, {
      context: $,
      modal: !1,
      disabled: !m,
      restoreFocus: !0,
      children: F
    })]
  });
});
process.env.NODE_ENV !== "production" && (ot.displayName = "SelectPopup");
const Fe = /* @__PURE__ */ n.forwardRef(function(t, u) {
  const {
    render: V,
    className: q,
    direction: g,
    keepMounted: w = !1,
    ...S
  } = t, {
    store: H,
    popupRef: d,
    listRef: y
  } = he(), {
    side: B,
    alignItemWithTriggerActive: D
  } = et(), _ = g === "up" ? v.scrollUpArrowVisible : v.scrollDownArrowVisible, M = T(H, _), j = ge(), O = n.useRef(null), {
    mounted: $,
    transitionStatus: b,
    setMounted: o
  } = Xe(M);
  De({
    open: M,
    ref: O,
    onComplete() {
      M || o(!1);
    }
  });
  const E = n.useMemo(() => ({
    direction: g,
    visible: M,
    side: B,
    transitionStatus: b
  }), [g, M, B, b]), s = ye("div", t, {
    ref: [u, O],
    state: E,
    props: [{
      hidden: !$,
      "aria-hidden": !0,
      children: g === "up" ? "▲" : "▼",
      style: {
        position: "absolute"
      },
      onMouseMove(A) {
        if (A.movementX === 0 && A.movementY === 0 || !D || j.isStarted())
          return;
        H.set("activeIndex", null);
        function e() {
          var L;
          const p = d.current;
          if (!p)
            return;
          H.set("activeIndex", null);
          const c = p.scrollTop === 0, C = Math.round(p.scrollTop + p.clientHeight) >= p.scrollHeight;
          if (g === "up" ? H.set("scrollUpArrowVisible", !c) : g === "down" && H.set("scrollDownArrowVisible", !C), g === "up" && c || g === "down" && C) {
            j.clear();
            return;
          }
          if (d.current && y.current && y.current.length > 0) {
            const a = y.current, P = ((L = O.current) == null ? void 0 : L.offsetHeight) || 0;
            if (g === "up") {
              let I = 0;
              const W = p.scrollTop + P;
              for (let F = 0; F < a.length; F += 1) {
                const l = a[F];
                if (l && l.offsetTop >= W) {
                  I = F;
                  break;
                }
              }
              const x = Math.max(0, I - 1), h = a[x];
              x < I && h && (p.scrollTop = h.offsetTop - P);
            } else {
              let I = a.length - 1;
              const W = p.scrollTop + p.clientHeight - P;
              for (let h = 0; h < a.length; h += 1) {
                const F = a[h];
                if (F && F.offsetTop + F.offsetHeight > W) {
                  I = Math.max(0, h - 1);
                  break;
                }
              }
              const x = Math.min(a.length - 1, I + 1);
              if (x > I) {
                const h = a[x];
                h && (p.scrollTop = h.offsetTop + h.offsetHeight - p.clientHeight + P);
              }
            }
          }
          j.start(40, e);
        }
        j.start(40, e);
      },
      onMouseLeave() {
        j.clear();
      }
    }, S]
  });
  return M || w ? s : null;
});
process.env.NODE_ENV !== "production" && (Fe.displayName = "SelectScrollArrow");
const nt = /* @__PURE__ */ n.forwardRef(function(t, u) {
  return /* @__PURE__ */ R.jsx(Fe, {
    ...t,
    ref: u,
    direction: "down"
  });
});
process.env.NODE_ENV !== "production" && (nt.displayName = "SelectScrollDownArrow");
const rt = /* @__PURE__ */ n.forwardRef(function(t, u) {
  return /* @__PURE__ */ R.jsx(Fe, {
    ...t,
    ref: u,
    direction: "up"
  });
});
process.env.NODE_ENV !== "production" && (rt.displayName = "SelectScrollUpArrow");
const ho = dt({
  slots: {
    root: ["Select__root group flex w-full flex-col gap-1 relative mb-2"],
    trigger: [
      "flex",
      "h-10",
      "min-w-36",
      "items-center",
      "justify-between",
      "gap-3",
      "rounded-xl",
      "border",
      "border-gray-300",
      "pr-3",
      "pl-3.5",
      "text-sm",
      "bg-common-white",
      "text-gray-900",
      "select-none",
      "hover:bg-gray-100",
      "focus:outline-none",
      "focus:border-primary-main",
      "focus:ring-2",
      "focus:ring-primary-light/50",
      "active:bg-gray-200",
      "data-[popup-open]:bg-gray-100",
      "group-data-[invalid]:border-error-main",
      "group-data-[invalid]:focus-within:ring-error-main/50"
    ],
    popup: [
      "group",
      // "max-h-[var(--available-height)]",
      "origin-[var(--transform-origin)]",
      "overflow-y-auto",
      "rounded-xl",
      "bg-white",
      "py-1",
      "text-gray-900",
      "outline",
      "outline-1",
      "outline-gray-300",
      "transition-[transform,scale,opacity]",
      "data-[ending-style]:scale-y-90",
      "data-[ending-style]:opacity-90",
      "data-[ending-style]:transition-none",
      "data-[starting-style]:scale-y-90",
      "data-[starting-style]:opacity-0",
      "data-[side=none]:data-[starting-style]:scale-90",
      "data-[side=none]:data-[starting-style]:opacity-90",
      "data-[side=none]:data-[starting-style]:transition-none",
      "max-h-[300px] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
    ],
    scrollUp: [
      "top-0 z-[1] flex h-4 w-full cursor-default items-center justify-center rounded-md bg-white text-center text-xs before:absolute before:top-[-100%] before:left-0 before:h-full before:w-full before:content-[''] data-[direction=down]:bottom-0 data-[direction=down]:before:bottom-[-100%]"
    ],
    scrollDown: [
      "bottom-0 z-[1] flex h-4 w-full cursor-default items-center justify-center rounded-md bg-white text-center text-xs before:absolute before:top-[-100%] before:left-0 before:h-full before:w-full before:content-[''] data-[direction=down]:bottom-0 data-[direction=down]:before:bottom-[-100%]"
    ],
    positioner: ["outline-none"],
    icon: ["flex"]
  },
  variants: {
    colSpan: {
      1: {
        root: ["col-span-1"]
      },
      2: {
        root: ["col-span-1 sm:col-span-2"]
      },
      3: {
        root: ["col-span-1 sm:col-span-3"]
      },
      4: {
        root: ["col-span-1 sm:col-span-4"]
      },
      5: {
        root: ["col-span-1 sm:col-span-5"]
      },
      6: {
        root: ["col-span-1 sm:col-span-6"]
      }
    }
  }
}), {
  root: yo,
  trigger: bo,
  popup: xo,
  scrollUp: vo,
  scrollDown: So,
  positioner: Ro,
  icon: wo
} = ho(), To = (r) => {
  const {
    value: t,
    onChange: u,
    options: V,
    required: q,
    label: g,
    name: w,
    align: S,
    colSpan: H,
    className: d,
    children: y,
    valueRender: B,
    error: D,
    helpText: _,
    loading: M,
    disabled: j,
    invalid: O,
    noLabel: $ = !1,
    ...b
  } = r, o = ft(pt(w).join(" ")), E = yt(y), m = E.length > 0, s = m ? E.map((c) => {
    const C = c;
    return {
      label: C.props.children,
      value: C.props.value,
      ...C.props
    };
  }) : void 0, A = `${m ? E.map((c) => c.props.value).join(",") : Array.isArray(V) ? V.map((c) => c.value).join(",") : ""}-${M}`, e = ht(() => m ? s : V, [V, m, s]);
  function p(c) {
    var C, L;
    return Array.isArray(c) && c.length === 0 ? "Select an option..." : !Array.isArray(c) && !b.multiple ? Array.isArray(e) ? (C = e.find(
      (a) => a.value == c
    )) == null ? void 0 : C.label : void 0 : Array.isArray(c) && !b.multiple ? Array.isArray(e) ? (L = e.find(
      (a) => a.value == c
    )) == null ? void 0 : L.label : void 0 : Array.isArray(e) && b.multiple ? e.filter((a) => c == null ? void 0 : c.includes(a.value)).map((a) => a.label).join(", ") : void 0;
  }
  return /* @__PURE__ */ R.jsxs(
    Mt,
    {
      invalid: !!D || O,
      className: yo({ colSpan: H, className: d }),
      validationMode: "onBlur",
      children: [
        (g || o) && /* @__PURE__ */ R.jsx(
          At,
          {
            className: mt({ required: q, hidden: $ }),
            autoFocus: !1,
            children: g || o
          }
        ),
        /* @__PURE__ */ R.jsxs(
          co,
          {
            modal: !1,
            onValueChange: u,
            required: q,
            name: w,
            value: t,
            disabled: M || j,
            ...b,
            items: m ? s : V,
            children: [
              /* @__PURE__ */ R.jsxs(
                Je,
                {
                  className: bo({ className: d }),
                  disabled: M || j,
                  children: [
                    /* @__PURE__ */ R.jsx(Ze, { render: B, className: "truncate", children: p }),
                    /* @__PURE__ */ R.jsx(Ge, { className: wo(), children: M ? /* @__PURE__ */ R.jsx(bt, { className: "animate-spin", size: 20 }) : /* @__PURE__ */ R.jsx(xt, { size: 20 }) })
                  ]
                }
              ),
              /* @__PURE__ */ R.jsx(po, { children: /* @__PURE__ */ R.jsxs(
                tt,
                {
                  className: Ro(),
                  sideOffset: 8,
                  align: S,
                  alignItemWithTrigger: !1,
                  children: [
                    /* @__PURE__ */ R.jsx(rt, { className: vo() }),
                    /* @__PURE__ */ R.jsx(ot, { className: xo(), children: m ? E : Array.isArray(V) ? V.map((c) => /* @__PURE__ */ R.jsx(
                      Tt,
                      {
                        value: c.value,
                        label: c.label !== void 0 ? String(c.label) : void 0
                      },
                      c.value
                    )) : y }),
                    /* @__PURE__ */ R.jsx(nt, { className: So() })
                  ]
                }
              ) })
            ]
          },
          A
        ),
        D ? /* @__PURE__ */ R.jsx(Ue, { className: Be({}), match: !0, children: D }) : /* @__PURE__ */ R.jsx(Ue, { className: Be({}) }),
        _ && /* @__PURE__ */ R.jsx(Ct, { className: gt({}), children: _ })
      ]
    }
  );
};
To.displayName = "Select";
export {
  To as default
};
